import { AbstractApiService } from "../abstractions/AbstractApiService";
import { OnRequestSuccess, OnRequestError } from "./Responses";
import { IDiseaseCategoryAddModel } from "../models/IDiseaseCategoryAddModel";

export class DiseaseCategoryService extends AbstractApiService {
    constructor() {
        super();
    }

    public AddMyDiseaseCategory(model: IDiseaseCategoryAddModel, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/diseasecategory/addmydiseasecategory', model, onSuccess, onError);
    }

    public AddMyDiseaseCategoryGroup(model: IDiseaseCategoryAddModel, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/diseasecategory/addmydiseasecategorygroup', model, onSuccess, onError);
    }

    public GetMyDiseaseCategoriesList(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/diseasecategory/mydiseasecategories', onSuccess, onError);
    }

    public SearchDiseaseCategories(searchValue: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/diseasecategory/searchdiseasecategories?searchValue=' + encodeURI(searchValue), onSuccess, onError);
    }

    public RemoveDiseaseCategory(diseaseCategoryName: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/diseasecategory/removemycategory', diseaseCategoryName, onSuccess, onError);
    }

    public RemoveDiseaseCategoryGroup(diseaseCategoryGroup: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/diseasecategory/removemycategorygroup', diseaseCategoryGroup, onSuccess, onError);
    }

    public GetDiseaseCategoriesForAcceptance(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/diseasecategory/acceptdiseasecategorylist', onSuccess, onError);
    }

    public AcceptDiseaseCategories(diseaseCategoriesToAccept: number[], onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/diseasecategory/acceptdiseasecategories', diseaseCategoriesToAccept, onSuccess, onError);
    }

    public DiscardDiseaseCategory(diseaseCategoryId: number, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Post('api/diseasecategory/discarddiseasecategory', diseaseCategoryId, onSuccess, onError);
    }

    public GetPhysiotherapistsDiseaseCategories(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/diseasecategory/getphysiotherapistsdiseasecategories?physiotherapistId=' + physiotherapistId,
            onSuccess,
            onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/DiseaseCategoryService.tsx